import styled from "styled-components"

export const Container = styled.div`
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.white};
`

export const Wrapper = styled.div`
  padding: 1.5rem 2rem;
  min-height: 30rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    margin-top: 2rem;
    font-weight: 700;
    font-size: 1.6rem;
  }

  svg {
    height: 10rem;
  }
`


export const FallbackButtonWrapper = styled.div`
 padding: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  border-top: 0.1rem solid ${(p) => p.theme.colors.borderLight};

`
